/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Severity of messages (corresponds to log levels used elsewhere)
 * @export
 */
export const SeverityConstants = {
    DEBUG: 'DEBUG',
    DETAIL: 'DETAIL',
    INFO: 'INFO',
    WARN: 'WARN',
    ERROR: 'ERROR'
} as const;
export type SeverityConstants = typeof SeverityConstants[keyof typeof SeverityConstants];


export function SeverityConstantsFromJSON(json: any): SeverityConstants {
    return SeverityConstantsFromJSONTyped(json, false);
}

export function SeverityConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeverityConstants {
    return json as SeverityConstants;
}

export function SeverityConstantsToJSON(value?: SeverityConstants | null): any {
    return value as any;
}

